import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

import { textPrimary } from 'app/components/ThemeProvider/colors';

const ChevronDownIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox='0 0 24 24'
      fill='none'
      sx={{ width: '24px', height: '24px', fill: 'none', ...sx }}
      {...props}
    >
      <path
        d='M5 9L12 16L19 9'
        stroke={textPrimary}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </SvgIcon>
  );
};

export default ChevronDownIcon;
